import HomeDataCardTracked from "app/pages/sales-intelligence/pages/home/containers/HomeDataCard/HomeDataCardTracked";
import type { ViewModelMetadata } from "app/pages/sales-intelligence/pages/home/types/models";
import type { ReactElement } from "react";
import type { HomeDataCardProps } from "../common/HomeDataCard/HomeDataCard";

const CARD_ID = "saved-searches";

type Props = Pick<HomeDataCardProps, "headerContent" | "children"> & {
    metadata: ViewModelMetadata;
};

const SavedSearchesCard = ({ children, headerContent, metadata }: Props): ReactElement => {
    return (
        <HomeDataCardTracked
            automationId={CARD_ID}
            title={{ key: `si.pages.home.card.${CARD_ID}.title` }}
            iconName="orange-search-v2-outline"
            headerContent={headerContent}
            metadata={metadata}
        >
            {children}
        </HomeDataCardTracked>
    );
}

export default SavedSearchesCard;
